<template>
  <div class = "container-xxl" style="font-family: 'Work Sans', sans-serif;">
    <div class="row text-center bg-white p-4" :style="headerStyle" >
      <div class="col-12 mb-2 my-3" style="max-height:3rem;"><img src="../assets/homepage/cloudlogo_red.png" height="100%"/></div>
      <h2 class="text-white mb-5" style="font-weight: 400;">Welcome to Enfyo Application</h2>
      <div class="col-12 my-5 " style="max-height:220px;"><img src="../assets/homepage/enfyo-device.png"  width="100%" style="max-width:400px;"/></div>
      <div class="col-12">
        <p class="lead">Enfyo webapp allows you to control and monitor your energy installation site locally or remotely (contact us to know more about your deployment options and limitations). 
        Use it together with Enfasys cloud for a 360-degree experience for the energy control and monitoring of all your sites and installations over the internet.
      </p>
      </div>
    </div>
    
    <div class="row text-center bg-white pt-3">
      <div class="col-sm-6 col-md-4">
        <div class="card h-100 border-white">
        <img src="../assets/homepage/icon_realtime.png" class="card-img-top mx-auto" style="max-height: 3rem; max-width: 3rem" alt="...">
          <div class="card-body">
            <!--h5 class="card-title">title</h5-->
            <p class="card-text">Manage your installation site with organized and valuable realtime information</p>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-4">
        <div class="card h-100 border-white">
        <img src="../assets/homepage/icon_diagnose.png" class="card-img-top mx-auto" style="max-height: 3rem; max-width: 3rem" alt="...">
          <div class="card-body">
            <p class="card-text">Configure and diagnose your connected Enfyo device using the config panel</p>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-4">
        <div class="card h-100 border-white">
        <img src="../assets/homepage/icon_user.png" class="card-img-top mx-auto" style="max-height: 3rem; max-width: 3rem " alt="...">
          <div class="card-body">
            <p class="card-text">Manager user or employee acounts with access privileges</p>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-4">
        <div class="card h-100 border-white">
        <img src="../assets/homepage/icon_safety.png" class="card-img-top mx-auto" style="max-height: 3rem; max-width: 3rem" alt="...">
          <div class="card-body">
            <p class="card-text">Your data is safe with local server security and the extended cloud storgae option</p>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-4">
        <div class="card h-100 border-white">
        <img src="../assets/homepage/icon_scale.png" class="card-img-top mx-auto" style="max-height: 3rem; max-width: 5rem" alt="...">
          <div class="card-body">
            <p class="card-text">Easily scale to multisite infrastructure installations or complex device and equipment implementation with cloud management</p>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-4">
        <div class="card h-100 border-white">
        <img src="../assets/homepage/icon_apitools.png" class="card-img-top mx-auto" style="max-height: 3rem; max-width: 3rem" alt="...">
          <div class="card-body">
            <p class="card-text">Extend or empower your own IoT ecosystem or on-site software with our flexible API toolset</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row text-center my-3 p-2">
      <p>Enfyo webapp is a software embeeded on the Enfasys devices, to work properly, it's necessary to count with local network infrastructure  
        and Enfasys-compatible monitoring devices. Enfyo work as an IoT gateway for electrical devices and equipment or for some IoT ready devices and subsystems
      </p>
      <p> When you login and use this application, you accept the Terms of Service and the <a href="#" target="_blank" rel="noopener noreferrer">Privacy Policy</a> 
        we don´t store personal data of any account or employee, cookies are needed for this site to operate but are destoyed immediately after leaving the site. 
        Contact us at <a href="#" target="_blank" rel="noopener noreferrer">Enfasys engineering</a> for more information.
      </p>
      <p class="text-danger">Contact us for more information about your specific devices and data needs and we'll be happy to provide you with the optimal configuration that fits your needs.</p>
    </div>
    <div class="row text-center bg-white p-5">
      <div><img src="../assets/homepage/enfasys-logo-fulltext.png" height="50" /></div>
    </div>

  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.min.css";
import { reactive } from 'vue';

export default {
  setup() {
    const headerStyle = reactive({ 
      backgroundImage: 'url(' + require('../assets/homepage/header.png') + ')', 
      backgroundPosition: 'center top',
      backgroundRepeat: 'no-repeat', 
    })
    const miniAvatarUrl = () => "'" + this.$appInfo.apiURL.substring(0, this.$appInfo.apiURL.length-3) + "webapp/enfasys-cabecera.jpg" + "'";


    return{
      headerStyle,
      miniAvatarUrl,
    }
  },
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,300;0,400;0,600;0,800;1,300;1,400;1,600;1,800&display=swap');

.home-container {
  max-width: 1350px;
  margin: 0 auto;
}
.home-par{
  font-size: 14px;
  color: #333333;
}

.logos-container {
  margin: 20px 0 40px 0;
  text-align: center;
  svg {
    display: inline-block;
  }
}

.devextreme-logo {
  width: 200px;
  height: 34px;
  margin-bottom: 17px;
}

.plus {
  margin: 20px 10px;
  width: 22px;
  height: 22px;
}

.screen-x-small .logos-container {
  svg {
    width: 100%;
    display: block;
    &.plus {
      margin: 0;
    }
  }
}



</style>
